(() => {
  if (window.CapirusEscepticas) return;

  async function addAndCheckout(form) {
    const button = form.querySelector('[type="submit"]');
    const msg = form.querySelector('.esc-buy-msg');
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    if (button) button.setAttribute('aria-busy', 'true');
    if (msg) msg.hidden = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('cart');
      window.location.assign(form.dataset.checkout || '/checkout');
    } catch (err) {
      if (button) button.removeAttribute('aria-busy');
      if (msg) {
        msg.textContent = form.dataset.error || 'No se pudo añadir. Inténtalo de nuevo.';
        msg.hidden = false;
      }
    }
  }

  function initBuyForms(root) {
    root.querySelectorAll('form[data-esc-buy]').forEach((form) => {
      if (form.dataset.escInit) return;
      form.dataset.escInit = '1';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        addAndCheckout(form);
      });
    });
  }

  function initBuybox(root) {
    root.querySelectorAll('[data-esc-buybox]').forEach((box) => {
      if (box.dataset.escInit) return;
      box.dataset.escInit = '1';
      const form = box.querySelector('form[data-esc-buy]');
      const idInput = form && form.querySelector('input[name="id"]');
      const label = box.querySelector('[data-esc-button-price]');
      const price = box.querySelector('[data-esc-price]');
      const compare = box.querySelector('[data-esc-compare]');
      const discount = box.querySelector('[data-esc-discount]');
      const perday = box.querySelector('[data-esc-perday]');
      const sync = () => {
        const checked = box.querySelector('input[data-esc-option]:checked');
        if (!checked) return;
        if (idInput) idInput.value = checked.value;
        if (label) label.textContent = checked.dataset.price || '';
        if (price) price.textContent = checked.dataset.price || '';
        if (compare) compare.textContent = checked.dataset.compare || '';
        if (discount) discount.textContent = checked.dataset.discount || '';
        if (perday) perday.textContent = checked.dataset.perday || '';
      };
      box.addEventListener('change', (event) => {
        if (event.target.matches('input[data-esc-option]')) sync();
      });
      sync();
    });
  }

  function initGalleries(root) {
    root.querySelectorAll('[data-esc-gallery]').forEach((gallery) => {
      if (gallery.dataset.escInit) return;
      gallery.dataset.escInit = '1';
      const track = gallery.querySelector('[data-esc-track]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-esc-thumb]'));
      if (!track) return;
      const slides = Array.from(track.children);
      const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const go = (index) => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: target * track.clientWidth });
      };
      const mark = () => {
        const index = current();
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
      const prev = gallery.querySelector('[data-esc-prev]');
      const next = gallery.querySelector('[data-esc-next]');
      if (prev) prev.addEventListener('click', () => go(current() - 1));
      if (next) next.addEventListener('click', () => go(current() + 1));
      track.addEventListener('scroll', () => window.requestAnimationFrame(mark), { passive: true });
      mark();
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-esc-carousel]').forEach((carousel) => {
      if (carousel.dataset.escInit) return;
      carousel.dataset.escInit = '1';
      const track = carousel.querySelector('[data-esc-track]');
      const pills = Array.from(carousel.querySelectorAll('[data-esc-filter]'));
      if (!track) return;
      const step = () => {
        const card = track.querySelector('.esc-proof__card:not([hidden])');
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      };
      const prev = carousel.querySelector('[data-esc-prev]');
      const next = carousel.querySelector('[data-esc-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step() }));
      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          const value = pill.dataset.escFilter;
          pills.forEach((p) => p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'));
          track.querySelectorAll('.esc-proof__card').forEach((card) => {
            const tags = (card.dataset.tags || '').split(',');
            card.hidden = value !== 'all' && !tags.includes(value);
          });
          track.scrollTo({ left: 0 });
        });
      });
    });
  }

  function init(root) {
    initBuyForms(root);
    initBuybox(root);
    initGalleries(root);
    initCarousels(root);
  }

  window.CapirusEscepticas = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
